var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("Permanent Sales")])]), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('auction-program-search', _vm._b({
    attrs: {
      "onlySearch": ""
    }
  }, 'auction-program-search', {
    totalCount: _vm.totalCount
  }, false))], 1), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('auction-category-select', _vm._b({
    attrs: {
      "value": _vm.category,
      "returnObject": "",
      "cols": "6",
      "sm": "4",
      "md": "3"
    },
    on: {
      "input": function input(category) {
        return _vm.$router.push("/permanent-sales/groups/".concat((category === null || category === void 0 ? void 0 : category.code) || 'all'));
      }
    }
  }, 'auction-category-select', {
    categories: _vm.categories
  }, false))], 1), _c('div', [_c('auction-work-list', {
    staticClass: "gallery-card-row",
    attrs: {
      "works": _vm.works
    }
  })], 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "mt-8 mb-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _this.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)]), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }